import React from "react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import "./webReport.css";
import Title from "../../components/Title";
import Item from "../../components/Item";
import ChallengeSummary from "./challengeSummary";
import DefinitionsGlossary from "./DefinitionsGlossary";
const LABEL_DEFINITION = {
  inspector: {
    type: "short-label",
    displayName: "Inspector",
  },
  inspectedDate: {
    type: "short-label",
    displayName: "Inspected Date",
  },
  name: {
    type: "short-label",
    displayName: "Name",
  },
  info: {
    type: "long-field-content",
    displayName: "Note",
  },
  apn: {
    type: "long-label",
    displayName: "Parcel Number",
  },
  address: {
    type: "long-field-content",
    displayName: "Address",
  },
  city: {
    type: "short-label",
    displayName: "City",
  },
  state: {
    type: "short-label",
    displayName: "State",
  },
  zipCode: {
    type: "short-label",
    displayName: "Postal Code",
  },
  year_build: {
    type: "short-label",
    displayName: "Year Built",
  },
  stories: {
    type: "long-label",
    displayName: "Number of Stories",
  },
  floor_area: {
    type: "short-label",
    displayName: "Square Feet",
  },
  report_type: {
    type: "short-label",
    displayName: "Report Type",
  },
  house_type: {
    type: "short-label",
    displayName: "House Type",
  },
};

const FIELDS_PER_ROW = [2, 3, 3, 2]; // Adjust this number as needed

const MetaDataSection = ({ metaDataItems, challenges, sectionNumbers }) => {
  const { "Project Information": projectInfo, Disclaimer: disclaimer } =
    metaDataItems;

  const { propertyDetails, summary } = projectInfo;

  let currentRowIndex = 0;
  const PropertyDetails = propertyDetails
    .filter((item) => item.value)
    .reduce((rows, item) => {
      // Create new row array if it doesn't exist
      if (!rows[currentRowIndex]) {
        rows[currentRowIndex] = [];
      }

      // Add the field to the current row
      rows[currentRowIndex].push(
        <div
          key={item.key}
          className={`field ${LABEL_DEFINITION[item.key]?.type}`}
        >
          <span className="label">
            {LABEL_DEFINITION[item.key]?.displayName}
          </span>
          <span className="field-content">{item.value}</span>
        </div>
      );

      if (rows[currentRowIndex].length === FIELDS_PER_ROW[currentRowIndex]) {
        currentRowIndex++;
      }

      return rows;
    }, []);

  const PropertyDetailsSection = (
    <>
      {PropertyDetails.map((row, index) => (
        <div key={index} className="info-row">
          {row}
        </div>
      ))}
    </>
  );

  const OverviewSection = <div className="info-row">{summary}</div>;

  return (
    <>
      {disclaimer && (
        <div className="metadata-container" id="inspection-scope-disclaimer">
          <Title
            text="Inspection Scope & Disclaimer"
            sectionNumber={sectionNumbers?.["inspection-scope-disclaimer"]}
          />
          <ReactMarkdown rehypePlugins={[rehypeRaw]}>
            {disclaimer}
          </ReactMarkdown>
        </div>
      )}

      <DefinitionsGlossary
        sectionNumber={sectionNumbers?.["definitions-glossary"]}
      />
      <div className="metadata-container" id="inspection-overview">
        <Title
          text="Inspection Overview"
          sectionNumber={sectionNumbers?.["inspection-overview"]}
        />
        <Item children={OverviewSection} showDivider={false} />
      </div>
      <ChallengeSummary
        challenges={challenges}
        sectionNumber={sectionNumbers?.["challenge-summary-section"]}
      />
      <div className="metadata-container" id="property-details">
        <Title
          text="Property Details"
          sectionNumber={sectionNumbers?.["property-details"]}
        />
        <Item children={PropertyDetailsSection} showDivider={false} />
      </div>
    </>
  );
};

export default MetaDataSection;
